// node:crypto のブラウザ代替。lib では randomBytes（uniqueGameId 用）と randomUUID のみ使用。
export function randomBytes(n) {
    const arr = new Uint8Array(n);
    crypto.getRandomValues(arr);
    return arr;
}

export function randomUUID() {
    return crypto.randomUUID();
}

export default { randomBytes, randomUUID };
